import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../common/Breadcrumbs";
import { useRole } from "../../context/RoleContext";
import { useNavigate, useParams } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import { Box, Button, Divider, Typography } from "@mui/material";
import {
  mainContainerStyle,
  paytextStyle,
  deviderStyle,
  headingStyle,
  inputLabelStyle,
  uploadButtonContainer,
  lableAndValueStyle,
  greyGridStyle,
  uploadPaymentStyle,
  transactionInputStyle,
  makePaymentButtonStyle,
  uploadDocumentStyle,
  fileUploadStyle,
} from "./PaymentStyle";
import { BankDetailsType } from "../../constants/types";
import { bankDetails } from "../../constants/bankDetail";
import { orderEndpoints } from "../../constants/endpoints";
import { api } from "../../api/api";
import { OrderDetails as OrderDetailsProps } from "../../dto/orderSummaryTypes";
import CustomDialog from "../../common/CustomDialog";
import moneyImage from "../../assets/money-image.png";
import crossIcon from "../../assets/crossIcon.png.png";
import { updateOrderPaymentService } from "../../service/orderPaymentService";
import { fileToBase64 } from "../../utils/fileToBase64";
import Toast from "../../common/Toast";

const Payment = () => {
  const [FileData, setFileData] = useState<{ file?: File }>({});
  const [transactionID, setTransactionID] = useState("");
  const [orderDetails, setOrderDetails] = useState<OrderDetailsProps>();
  const [dialogOpen, setDialogOpen] = useState(false);
  const { role } = useRole();
  const { id: orderId } = useParams();
  const [error, setError] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const total = parseFloat(orderDetails?.payment?.subtotal || "0") / 100;

  const formattedTotal = total.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
  });
  const navigate = useNavigate();
  const orgId = localStorage.getItem("orgId");

  const isSellerPortal = () => {
    if (role === "seller" || location.pathname.includes("/seller")) {
      return true;
    }
    return false;
  };
  const getLinks = () => {
    if (isSellerPortal()) {
      return ["/seller/orders", "#"];
    }
    return [
      "/customer/home",
      "/customer/my-orders",
      `/customer/order-summary/${orderId}`,
      "#",
    ];
  };
  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      setFileData({ file });
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTransactionID(e.target.value);
  };

  const getOrderDetails = async () => {
    try {
      const response = await api.get(`${orderEndpoints.getOrder}/${orderId}`);
      if (response.data) {
        setOrderDetails(response.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const processFile = async (file?: File) => {
    if (!file) return null;

    const base64Content = await fileToBase64(file);

    return {
      fileName: file.name,
      fileContent: base64Content,
      fileType: file.type,
    };
  };

  const handlePayment = async () => {
    try {
      if (Object.keys(FileData).length > 0) {
        const uploadFile = await processFile(FileData?.file);
        await updateOrderPaymentService(
          { uploadedDocuments: [uploadFile], newPayment: true },
          orderId ?? ""
        );
        setDialogOpen(true);
      } else if (!Object.keys(FileData).length && transactionID)
        await updateOrderPaymentService(
          { transactionId: transactionID, newPayment: true },
          orderId ?? ""
        );
      setDialogOpen(true);
    } catch (error: any) {
      console.log(error);
      setToastMessage("Failed To upload the Payment Receipt");
      setError(true);
      setShowToast(true);
    }
  };
  const handleClose = () => {
    setDialogOpen(false);
  };
  const backToHome = () => {
    handleClose();
    navigate(`/${orgId}/customer/home`);
  };
  const handleRemoveFile = () => {
    setFileData({});
  };

  useEffect(() => {
    getOrderDetails();
  }, [orderId]);

  return (
    <>
      <Breadcrumbs
        paths={
          isSellerPortal()
            ? ["All Orders", "Edit Order Status"]
            : ["Home", "My Orders", "Order Confirmation", "Payment"]
        }
        links={getLinks()}
      />
      <Box sx={mainContainerStyle}>
        <Grid container spacing={1}>
          <Grid
            size={{ xs: 12, sm: 6, md: 7 }}
            sx={{ marginTop: "14px", mb: "14px" }}
          >
            <Typography sx={{ ...paytextStyle, marginTop: "12px" }}>
              Make the payment to the bank details provided below
            </Typography>
            <Grid container spacing={[0, 2]}>
              {bankDetails.map((detail: BankDetailsType, index) => (
                <Grid key={index} size={{ xs: 12, sm: 6, md: 6 }}>
                  <Box sx={lableAndValueStyle}>
                    <Typography sx={headingStyle}>{detail.label}</Typography>
                    <Typography sx={inputLabelStyle}>{detail.value}</Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 5 }} sx={greyGridStyle}>
            {" "}
            <Typography sx={paytextStyle}>
              After completing your payment, please either upload a receipt or
              screenshot with the transaction details or provide the Transaction
              ID below.
            </Typography>
            <Typography mt={3} sx={uploadPaymentStyle}>
              Upload a payment receipt or screenshot here
            </Typography>
            <label htmlFor="UploadButton">
              <Button
                variant="outlined"
                component="span"
                style={uploadButtonContainer}
              >
                <Typography sx={{ ...uploadPaymentStyle, fontSize: "12px" }}>
                  Choose file
                </Typography>
              </Button>
            </label>
            <input
              type="file"
              id="UploadButton"
              data-testid="fileUpload"
              onChange={handleFileUpload}
              style={fileUploadStyle}
            />
            {/* Show uploaded file name below */}
            {FileData.file && (
              <Typography mt={3} sx={uploadDocumentStyle}>
                {FileData.file.name}
                <img
                  onClick={handleRemoveFile}
                  alt="remove file"
                  src={crossIcon}
                  style={{ cursor: "pointer" }}
                />
              </Typography>
            )}
            <Divider style={deviderStyle}>
              <strong>or</strong>
            </Divider>
            <Typography sx={uploadPaymentStyle}>Transaction Id*</Typography>
            <input
              type="text"
              id="transaction-id"
              style={transactionInputStyle}
              data-testid="transaction-id"
              onChange={handleInputChange}
            />
            <Box sx={{ flexGrow: 1 }} />
            <Button
              size="large"
              variant="contained"
              sx={makePaymentButtonStyle}
              onClick={handlePayment}
              disabled={!FileData.file && !transactionID}
            >
              {!FileData.file && !transactionID
                ? `Pay ${formattedTotal}`
                : `Paid ${formattedTotal}`}
            </Button>
          </Grid>
        </Grid>
      </Box>
      {dialogOpen && (
        <CustomDialog
          open={dialogOpen}
          onClose={handleClose}
          imageSrc={moneyImage}
          content="Thank you for your payment. Our team will review it shortly and get back to you soon."
          buttonText="Done"
          onButtonClick={backToHome}
          showCloseIcon={false}
        />
      )}

      <Toast
        showToast={showToast}
        setShowToast={setShowToast}
        toastMessage={toastMessage}
        error={error}
      />
    </>
  );
};

export default Payment;
